module.exports = __webpack_public_path__ + "mural.png?7f73ed7b887e3b4e141839272134b0d5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/mural.png
// module id = 189
// module chunks = 0